import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-eligibility-rule-form-has-relation',
    templateUrl: './editor-eligibility-rule-form-has-relation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleFormHasRelationComponent implements OnInit, OnDestroy {
  @Input() formGroup: FormGroup;

  private destroyed$ = new Subject<void>();

  relationNamesWithCategoryNames: { id: string, name: string, categoryNames: { id: string, name: string }[] }[];

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.relationNamesWithCategoryNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        relationNamesWithCategoryNames =>
          this.relationNamesWithCategoryNames = relationNamesWithCategoryNames
      );
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getRelationName(): string {
    if (this.relationNamesWithCategoryNames === undefined) { return ''; }

    return this.relationNamesWithCategoryNames.find(
      relationName => relationName.id === this.formGroup.value.relation
    )?.name ?? $localize `Not valid`;
  }

  getRelationCategories(): { id: string, name: string }[] {
    if (this.relationNamesWithCategoryNames === undefined) { return []; }

    return this.relationNamesWithCategoryNames.find(
      relationName => relationName.id === this.formGroup.value.relation
    )?.categoryNames ?? [];
  }
}
